type IncomingHandler = (contactId: string) => void;

let handler: IncomingHandler | null = null;

export function setIncomingCallHandler(next: IncomingHandler | null): void {
  handler = next;
}

export function notifyIncomingCall(contactId: string): void {
  handler?.(contactId);
}
